import { Button } from '@material-ui/core';
import { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { EventsTable } from "../../components/EventsTable";
import { TaskSearchBar } from "../../components/TaskSearchBar";

export const WaterEvents = () => {
    const [filterText, setFilterText] = useState<string>("");

    return (
        <Fragment>
            <h1>Add New Events</h1>
            <Link to={"water/add"}>
                <Button variant="contained" color="primary">
                    Create
                </Button>
            </Link>
            <TaskSearchBar onNewFilterText={setFilterText}/>
            <h1>My Water Events to Review</h1>
            <EventsTable userOnly={true} taskType="Water" filterText={filterText}/>

            <h1>All Water Events to Review</h1>
            <EventsTable userOnly={false} taskType="Water" filterText={filterText}/>

            <h1>Tagged Water Events</h1>
            <EventsTable userOnly={false} getArchived={true} taskType="Water" filterText={filterText}/>
        </Fragment>
    )
}